import React from "react";
import {Button, Drawer, Layout, Empty, message, Modal, notification} from 'antd';
import DataContainer from "./components/DataContainer";
import Header from "./components/Header";
import LogoutButton from "./components/LogoutButton";
import {ExclamationCircleOutlined, WarningOutlined, CheckCircleOutlined} from '@ant-design/icons';

import './App.less';

const {Footer, Content} = Layout;

const loading = () => {
	message.loading({content: 'Changes being submitted...', key: 'loading', duration: 0}).then();

};

const successNotification = () => {
	const key = `publish-success`;
	const btn = (
		<Button type="primary" size="small" onClick={() => notification.close(key)}>
			Confirm
		</Button>
	);
	const icon = (<CheckCircleOutlined style={{color: 'green'}}/>);
	message.destroy('loading')
	notification.open({
		message: 'Success',
		description:
			'Changes have been submitted.',
		btn,
		key,
		icon,
		duration: 0
	});
};

const openNotification = () => {
	const key = `publish-error`;
	const btn = (
		<Button type="primary" size="small" onClick={() => notification.close(key)}>
			Confirm
		</Button>
	);
	const icon = (<WarningOutlined style={{color: 'red'}}/>);
	message.destroy('loading')
	notification.open({
		message: 'Error....',
		description:
			'Something went wrong, changes have not been submitted. Seek assistance.',
		btn,
		key,
		icon,
		duration: 0
	});
};

export default class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			appDrawVisible: false,
			appDrawPlacement: 'right',
			origData: {},
			data: [],
			dataType: "",
			sessionChanges: [],
			selectedApp: null,
			modalVisible: false,
			interactives: {}
		}
	}
	componentDidMount() {
		this.getInteractives().then();
	}

	getInteractives = async () => {
		let d = new Date();
		let time = d.getTime();
		let newUrl = `https://storage.googleapis.com/json-updater.insiteplans.com.au/interactives.json?v=${time}`;
		const json = await fetch(newUrl)
			.then(response => response.json());
		// const interactives = JSON.parse(json);
		this.setState({
			interactives: json
		});
	};

	showDrawer = () => {
		this.setState({
			appDrawVisible: true,
		});
	};

	onClose = () => {
		this.setState({
			appDrawVisible: false,
		});
	};

	showModal = () => {
		this.setState({
			modalVisible: true,
		});
	};

	hideModal = () => {
		this.setState({
			modalVisible: false,
		});
	};

	selectAnApp = () => {
		if (this.state.sessionChanges.length > 0) {
			this.showModal();
		} else {
			this.showDrawer();
		}
	};

	selectInteractive = (event) => {
		this.onClose();
		let app = event.target.innerText;
		this.setState({
			sessionChanges: []
		});
		this.getData(this.state.interactives[app].dataUrl, this.state.interactives[app]).then(this.formatData);
	};

	getData = async (url, selectedApp) => {
		let d = new Date();
		let time = d.getTime();
		let newUrl = `${url}?v=${time}`;
		const json = await fetch(newUrl)
			.then(response => response.json());
		this.setState({
			origData: json,
			selectedApp: selectedApp
		});
	};

	formatData = () => {
		let origData = this.state.origData;
		let apartmentKey = false;
		let levelsKey = false;
		let buildingKey = false
		let bedroomKey = false;

		if (Object.keys(origData).length === 1) {
			let keys = Object.keys(origData);
			let data = origData[keys[0]];
			let newKeys = Object.keys(data);

			if (newKeys.includes('Apartments') || newKeys.includes('apartments')) {
				apartmentKey = true;
			} else if (newKeys.includes('Buildings') || newKeys.includes('buildings')) {
				buildingKey = true;
			} else if (newKeys.includes('Levels') || newKeys.includes('levels')) {
				levelsKey = true;
			} else {
				console.log('something went wrong: 1')
			}
		} else {
			let keys = Object.keys(origData);

			if (keys.includes('Apartments') || keys.includes('apartments')) {
				apartmentKey = true;
			} else if (keys.includes('Buildings') || keys.includes('buildings')) {
				buildingKey = true;
			} else if (keys.includes('Levels') || keys.includes('levels')) {
				levelsKey = true;
			} else if (keys.includes('data') || keys.includes('Data')) {
				bedroomKey = true;
			} else {
				console.log('something went wrong: dont know which data structure.')
			}
		}

		if (apartmentKey) {
			this.apartmentsStructure();
		} else if (levelsKey) {
			this.levelsStructure();
		} else if (buildingKey) {
			this.buildingsStructure();
		} else if (bedroomKey) {
			this.bedroomStructure();
		} else {
			console.log('something went wrong: 3');
		}
	};

	apartmentsStructure = () => {
		let origData = this.state.origData;
		let keys = Object.keys(origData);
		let data = origData[keys[0]];
		let apartments = [];
		if (data['apartments']) {
			console.log("we got apartments");
			apartments = data['apartments'];
			this.setState({
				data: apartments,
				dataType: "apartments"
			})
		} else {
			console.log("no apt: something wrong;")
		}

	};

	levelsStructure = () => {
		let origData = this.state.origData;
		let levels = [];
		if (origData['levels']) {
			console.log("we got levels");
			levels = origData['levels'];
			this.setState({
				data: levels,
				dataType: "levels"
			})
		} else {
			console.log("no levels: something wrong;")
		}
	};

	buildingsStructure = () => {
		let origData = this.state.origData;
		let buildings = [];
		if (origData['buildings']) {
			console.log("we got buildings");
			buildings = origData['buildings'];
			this.setState({
				data: buildings,
				dataType: "buildings"
			})
		} else {
			console.log("no buildings: something wrong;")
		}
	};

	bedroomStructure = () => {
		console.log('bedroom structure');
		let origData = this.state.origData;
		let bedrooms = [];
		if(origData['data']) {
			bedrooms = origData['data'];
			this.setState({
				data: bedrooms,
				dataType: "bedrooms"
			});
		} else {
			console.log("no bedrooms: something wrong;")
		}
	};

	statusChange = (event) => {
		console.log("status changed")
		let target = event.target;
		let value = target.value;
		let data = this.state.data;
		let dataType = this.state.dataType;
		let sessionChanges = this.state.sessionChanges;
		let changeAdded = false;
		let originalAptStatus = null;

		if (dataType === "levels") {
			for (let i = 0; i < data.length; i++) {
				for (let ii = 0; ii < data[i].apartments.length; ii++) {
					if (data[i].apartments[ii].name == target.name) {
						originalAptStatus = data[i].apartments[ii].status;
						data[i].apartments[ii].status = parseInt(value);
						break;
					}
				}
			}
		} else if (dataType === "apartments") {
			for (let i = 0; i < data.length; i++) {
				if (data[i].id == target.name) {
					originalAptStatus = data[i].status;
					data[i].status = parseInt(value);
					break;
				}
			}
		} else if (dataType === "buildings") {
			for (let i = 0; i < data.length; i++) {
				for (let ii = 0; ii < data[i].levels.length; ii++) {
					for (let iii = 0; iii < data[i].levels[ii].apartments.length; iii++) {
						if (data[i].levels[ii].apartments[iii].name == target.name) {
							originalAptStatus = data[i].levels[ii].apartments[iii].status;
							data[i].levels[ii].apartments[iii].status = parseInt(value);
							break;
						}
					}
				}
			}
		} else if(dataType === "bedrooms") {
			for (let i = 0; i < data.length; i++){
				for (let ii = 0; ii < data[i].types.length; ii++){
					for (let iii = 0; iii < data[i].types[ii].apartments.length; iii++){
						if(data[i].types[ii].apartments[iii].apartment == target.name) {
							originalAptStatus = data[i].types[ii].apartments[iii].status;
							data[i].types[ii].apartments[iii].status = parseInt(value);
							break;
						}
					}
				}
			}
		}

		for (let i = 0; i < sessionChanges.length; i++) {
			if (sessionChanges[i].name === target.name) {
				if (sessionChanges[i].originalStatus === parseInt(value)) {
					sessionChanges.splice(i, 1);
				} else {
					// sessionChanges[i].id = target.id;
					sessionChanges[i].name = target.name;
					sessionChanges[i].status = parseInt(target.value);
				}
				changeAdded = true;
			}
		}

		if (!changeAdded) {
			sessionChanges.push(
				{
					'name': target.name,
					'status': parseInt(target.value),
					'originalStatus': originalAptStatus
				}
			);
		}

		this.setState({
			data: data,
			sessionChanges: sessionChanges
		});
	};

	clearSessionChanges = () => {
		let newState = Object.assign(this.state, {
			sessionChanges: []
		});

		this.setState(newState);
	};

	publishChanges = async () => {
		loading();

		// let url = "http://localhost:16080/api/update-json";
		let url = 'https://json-updater-service-dot-plansonline.appspot.com/api/update-json';
		let data = {
			"app": this.state.selectedApp,
			"data": this.state.origData
		};

		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		}).then((response) => {
			if (!response.ok) {
				throw Error(response.statusText);
			}
			return response.json()
		}).then(data => {
			if (data) {
				this.clearSessionChanges();
				message.destroy('loading')
				successNotification();
			} else {
				openNotification();
			}
		}).catch(openNotification);
	};

	render() {
		const {appDrawVisible, appDrawPlacement} = this.state;
		let interactiveNames = Object.keys(this.state.interactives);
		let goToAppBtn = this.state.selectedApp === null;
		let goToAppBtnHref = this.state.selectedApp === null ? '' : this.state.selectedApp.appUrl;
		let buttonActive = !this.state.sessionChanges.length > 0;
		let headerButtons = [
			<LogoutButton key={4}/>,
			<Button key="3" type="primary" onClick={this.selectAnApp}>Select an App</Button>,
			<Button key="2" type="primary" disabled={goToAppBtn} href={goToAppBtnHref} target={'_blank'}>Go to App</Button>,
			<Button key="1" type="danger" disabled={buttonActive} onClick={this.publishChanges}>Publish Changes</Button>,
		];

		return (
			<Layout>
				<Header buttons={headerButtons} changes={this.state.sessionChanges}/>
				<Content style={{marginTop: '120px', padding: '0 24px', backgroundColor: '#333a41'}}>
					<div className="site-layout-content">
						{this.state.selectedApp === null ?
							<Empty
								image={Empty.PRESENTED_IMAGE_SIMPLE}
								imageStyle={{
									height: 60,
								}}
								description={
									<span>No App Selected.</span>
								}/> :
							<DataContainer
								selectedApp={this.state.selectedApp}
								data={this.state.data}
								dataType={this.state.dataType}
								statusChange={this.statusChange}
							/>
						}
					</div>
				</Content>
				<Footer style={{textAlign: 'center', backgroundColor: '#333a41'}}></Footer>
				<Drawer
					title="Apps"
					placement={appDrawPlacement}
					closable={true}
					onClose={this.onClose}
					visible={appDrawVisible}
					key={appDrawPlacement}
				>
					{interactiveNames.map((app, index) => {
						if (this.state.interactives[app].active) {
							return <p className={'draw-app-title'} key={index} onClick={this.selectInteractive}>{app}</p>
						} else {
							return null
						}
					})}
				</Drawer>
				<Modal
					title="Wait a sec..."
					visible={this.state.modalVisible}
					onOk={() => {
						this.hideModal();
						this.showDrawer();
					}}
					onCancel={this.hideModal}
					okText="Continue"
					cancelText="Cancel"
				>
					<div className={'modal-container'}>
						<ExclamationCircleOutlined style={{fontSize: '32px', color: 'red'}}/>
						<div className={'modal-div'}>
							<p className={'modal-para'}> You have unsubmitted changes.</p>
							<p className={'modal-para'}>If you continue and select a new app current changes will be lost.</p>
						</div>
					</div>
				</Modal>
			</Layout>
		)
	}
}
